<template>
    <main>
        <div class="footer">
            <p>© 2023 Developed by Tenwave Infotech Pvt Ltd</p>
        </div>
    </main>
</template>

<script>


export default {
    name: "navfooter"
    
}
</script>
